var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-content',{attrs:{"pagetype":"1","pagename":"slitdigitalexperience","title":_vm.$t('sl.itandxpdigitale.title'),"titlecolor":"darkgreen"}})}
var staticRenderFns = []

export { render, staticRenderFns }